/* NW Wellness — Collection filters + product grid
   Auto-submit on filter change so URL keeps state; mobile drawer toggle. */

(function () {
  const sectionEl = document.querySelector('[data-section-id]');
  const filtersForm = document.querySelector('[data-nw-filters]');
  const sortSelect = document.querySelector('[data-nw-sort]');
  const railEl = document.getElementById('NWFilters');
  const toggleBtn = document.querySelector('[data-nw-action="toggle-filters"]');

  if (filtersForm) {
    // Auto-submit when any filter input changes
    filtersForm.addEventListener('change', () => {
      // Strip empty/disabled fields so the URL stays clean
      Array.from(filtersForm.elements).forEach((el) => {
        if (el.disabled || (el.type === 'checkbox' && !el.checked && el.name !== 'sort_by')) {
          el.disabled = true;
        }
      });
      filtersForm.submit();
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  if (toggleBtn && railEl) {
    toggleBtn.addEventListener('click', () => {
      const open = railEl.hasAttribute('data-open');
      if (open) {
        railEl.removeAttribute('data-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
        // Return focus to the toggle (global.js utility, same as MenuDrawer)
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(toggleBtn);
        } else {
          toggleBtn.focus();
        }
      } else {
        railEl.setAttribute('data-open', '');
        toggleBtn.setAttribute('aria-expanded', 'true');
        // Trap focus inside the open drawer (global.js utility)
        if (typeof trapFocus === 'function') {
          trapFocus(railEl, railEl.querySelector('input:not([type="hidden"]):not(:disabled), button, a') || railEl);
        }
      }
    });
  }
})();
